/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BridgeApiAttachment
 */
export interface BridgeApiAttachment {
    /**
     * 
     * @type {string}
     * @memberof BridgeApiAttachment
     */
    handle: string;
    /**
     * 
     * @type {string}
     * @memberof BridgeApiAttachment
     */
    fileName: string;
    /**
     * 
     * @type {Date}
     * @memberof BridgeApiAttachment
     */
    createdTime: Date;
}

/**
 * Check if a given object implements the BridgeApiAttachment interface.
 */
export function instanceOfBridgeApiAttachment(value: object): value is BridgeApiAttachment {
    if (!('handle' in value) || value['handle'] === undefined) return false;
    if (!('fileName' in value) || value['fileName'] === undefined) return false;
    if (!('createdTime' in value) || value['createdTime'] === undefined) return false;
    return true;
}

export function BridgeApiAttachmentFromJSON(json: any): BridgeApiAttachment {
    return BridgeApiAttachmentFromJSONTyped(json, false);
}

export function BridgeApiAttachmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): BridgeApiAttachment {
    if (json == null) {
        return json;
    }
    return {
        
        'handle': json['handle'],
        'fileName': json['fileName'],
        'createdTime': (new Date(json['createdTime'])),
    };
}

export function BridgeApiAttachmentToJSON(json: any): BridgeApiAttachment {
    return BridgeApiAttachmentToJSONTyped(json, false);
}

export function BridgeApiAttachmentToJSONTyped(value?: BridgeApiAttachment | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'handle': value['handle'],
        'fileName': value['fileName'],
        'createdTime': value['createdTime'].toISOString(),
    };
}

